import Loading from "src/components/Loading";

export default function Fallback() {
    return (
        <div id="preloader">
            <Loading />
        </div>
    );
}
